export default __webpack_public_path__ + "static/media/Sharing.c5a68680.png";